export default __webpack_public_path__ + "static/font-7b5ad4628253c52b535b4d7fa1b43782.woff2";